import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { isCurrentRowTheFooter } from "../utils";
import { language } from "language/default";
import { setDetailsPanel } from "store/current-dashboard";
import { DetailsPanelType } from "store/current-dashboard/types";
export const ChangeBenchmarkButtonCellRenderer = (params) => {
    const dispatch = useDispatch();
    const handleClick = useCallback(() => {
        dispatch(setDetailsPanel({
            context: {
                benchmarkId: params.data?.FundBenchmarkId ?? params.data?.BenchmarkId,
                benchmarkName: params.data?.FundBenchmarkName,
                constituents: params.data?.NumberOfConstituents,
                dpiRanking: params.data?.FundQuartileRankingDPI,
                dpiValue: params.data?.FundDPI,
                fundId: params.data?.FundId,
                fundName: params.data?.FundName,
                investmentId: params.data?.InvestmentId,
                investorId: params.data?.InvestorId,
                irrRanking: params.data?.FundQuartileRankingIRR,
                irrValue: params.data?.FundNetIRR,
                piccRanking: params.data?.FundQuartileRankingPICC,
                piccValue: params.data?.FundPICC,
                referenceDate: params.data?.FundBenchmarkReferenceDate,
                tvpiRanking: params.data?.FundQuartileRankingTVPI,
                tvpiValue: params.data?.FundTVPI
            },
            isOpen: true,
            title: language.en.funds.benchmark.reviewAndChangeBenchmark + params.data?.FundName,
            type: DetailsPanelType.ChangeBenchmark
        }));
    }, [dispatch, params.data]);
    if (isCurrentRowTheFooter(params.node) || params.node?.group) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(AuxButton, { icon: "edit", onClick: handleClick, size: AuxButtonSizeEnum.XSMALL, type: AuxButtonTypeEnum.TERTIARY }));
};
